module.exports = __webpack_public_path__ + "static/media/IMG_1764.4ba17924.JPG";